// extracted by mini-css-extract-plugin
export var activeLink = "collection-tags-module--activeLink--3f088";
export var navLink = "collection-tags-module--navLink--4f378";
export var navStyle = "collection-tags-module--navStyle--41b4e";